export const BUCKET_USER_GENERATED = 'user-generated-images';
export const BUCKET_INSPIRATION_GALLERY = 'inspiration-gallery-images';
export const BUCKET_ASSISTANT_DOCS = 'assistant-docs';
export const BUCKET_ORG_SYNC = 'org-syncs';
export const ORG_ONBOARDING_CSV_UPLOADS = 'org-onboarding-csv-uploads';
export const BUCKET_REVIEWER_SUBMISSION_PDFS = 'reviewer-submission-pdfs';
export const BUCKET_KNOWLEDGE_BASE = 'knowledge-base';
export const BUCKET_USER_DOCUMENT_UPLOADED = 'user-document-uploads';
export const BUCKET_ORG_LOGOS = 'org_logos';
export const BUCKET_EDUCATIONAL_SONGS = 'educational-songs';
export const BUCKET_EDUCATIONAL_PODCASTS = 'educational-podcasts';
export const BUCKET_INTEGRATIONS_BRONZE = 'integrations-bronze';
// EAS-643: internal, service-role-only store for legacy file_search parity baselines (JSON snapshots).
export const BUCKET_PARITY_BASELINES = 'parity-baselines';
export const BUCKET_PRESENTATION_DECK_UPLOADS = 'presentation-deck-uploads';
export const BUCKET_PRESENTATION_DECK_EXPORTS = 'presentation-deck-exports';
